import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHUnidadUpd = async (credentials, data) => {
    const body = {
        service: "RNHUnidadUpd",
        params: {
            rnhUnidadId: data?.id,
            rnhUnidadCod: data?.cod,
            rnhUnidadNombre: data?.name,
            rnhUnidadDescripcion: data?.desc,
            rnhDepartamentoId: data?.departamentoId || null,
            rnhDivisionId: data?.divisionId || null,
            rnhUnidadVersion: data?.version,
            rnhUnidadAdmiteRotativos: data?.admiteRotativos || null,
            rnhUnidadAdmiteGuardias: data?.admiteGuardias || null,
        },
    };

  return respuestaDe(await axiosPost(body, credentials));
};
